import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ContentProvider } from "@/context/ContentContext";

import SiteLayout from "@/components/site/SiteLayout";
import Home from "@/pages/Home";
import AssurancesPro from "@/pages/services/AssurancesPro";
import SantePrevoyance from "@/pages/services/SantePrevoyance";
import Patrimoine from "@/pages/services/Patrimoine";
import Methode from "@/pages/Methode";
import Partenaires from "@/pages/Partenaires";
import Contact from "@/pages/Contact";
import MentionsLegales from "@/pages/MentionsLegales";

import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminLeads from "@/pages/admin/AdminLeads";
import AdminPartners from "@/pages/admin/AdminPartners";
import AdminContent from "@/pages/admin/AdminContent";
import AdminSEO from "@/pages/admin/AdminSEO";
import AdminLegal from "@/pages/admin/AdminLegal";
import ProtectedRoute from "@/components/admin/ProtectedRoute";

import "@/App.css";

function App() {
  return (
    <AuthProvider>
      <ContentProvider>
        <BrowserRouter>
          <Toaster theme="dark" position="top-right" richColors closeButton />
          <Routes>
            <Route element={<SiteLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/assurances-professionnelles" element={<AssurancesPro />} />
              <Route path="/sante-prevoyance" element={<SantePrevoyance />} />
              <Route path="/patrimoine-placements" element={<Patrimoine />} />
              <Route path="/methode" element={<Methode />} />
              <Route path="/partenaires" element={<Partenaires />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/mentions-legales" element={<MentionsLegales />} />
            </Route>

            <Route path="/admin/login" element={<AdminLogin />} />
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <AdminLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<AdminDashboard />} />
              <Route path="leads" element={<AdminLeads />} />
              <Route path="partenaires" element={<AdminPartners />} />
              <Route path="contenus" element={<AdminContent />} />
              <Route path="seo" element={<AdminSEO />} />
              <Route path="mentions" element={<AdminLegal />} />
            </Route>

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </ContentProvider>
    </AuthProvider>
  );
}

export default App;
